import React, { useEffect, useState, useCallback } from "react";
import api from "./api";

export default function SalesRepPerformanceWidget({ date }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPerformance = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/api/admin/sales-reps/performance", {
        params: { date },
      });
      setData(res.data || []);
    } catch (error) {
      console.error("Failed to load sales rep performance", error);
    } finally {
      setLoading(false);
    }
  }, [date]);

  useEffect(() => {
    fetchPerformance();
  }, [fetchPerformance]);
  /* =========================
     LOADING STATE
  ========================= */
  if (loading) {
    return (
      <div className="rounded-xl bg-white p-4 shadow-sm text-sm text-gray-500">
        Loading sales rep performance…
      </div>
    );
  }

  /* =========================
     UI
  ========================= */
  return (
    <div className="rounded-xl bg-white p-5 shadow-sm">
      {/* Header */}
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-800">
          📊 Sales Rep Performance
        </h3>
        <span className="text-xs text-gray-500">SLA ≤ 5 min</span>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left text-gray-500">
              <th className="py-2 font-medium">Rep</th>
              <th className="py-2 font-medium">Avg RT</th>
              <th className="py-2 font-medium">On-time</th>
              <th className="py-2 font-medium">Chats</th>
              <th className="py-2 font-medium">Missed</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={5} className="py-4 text-center text-gray-400">
                  No data available
                </td>
              </tr>
            ) : (
              data.map((rep) => (
                <tr key={rep.sales_rep_id} className="border-b last:border-0">
                  <td className="py-2 font-medium text-gray-800">
                    #{rep.sales_rep_id}
                  </td>

                  <td
                    className={`py-2 font-semibold ${getColor(
                      rep.avg_response_time,
                      "rt"
                    )}`}
                  >
                    {rep.avg_response_time}m
                  </td>

                  <td
                    className={`py-2 font-semibold ${getColor(
                      rep.on_time_percentage,
                      "otp"
                    )}`}
                  >
                    {rep.on_time_percentage}%
                  </td>

                  <td className="py-2 text-gray-700">
                    {rep.conversations_handled}
                  </td>

                  <td
                    className={`py-2 font-semibold ${
                      rep.missed_replies > 5 ? "text-red-600" : "text-green-600"
                    }`}
                  >
                    {rep.missed_replies}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* =========================
   HELPERS
========================= */
function getColor(value, type) {
  if (type === "rt") {
    if (value <= 5) return "text-green-600";
    if (value <= 10) return "text-yellow-500";
    return "text-red-600";
  }

  if (type === "otp") {
    if (value >= 80) return "text-green-600";
    if (value >= 60) return "text-yellow-500";
    return "text-red-600";
  }

  return "text-gray-600";
}
